import { Card } from '../../components/ui/Card';
import { PageHeader } from '../../components/ui/PageHeader';
import { getAllTiers, formatPrice, formatYearlyPrice, isTeamTier, TRIAL_ONCE_RULE } from '../../constants/tiers';

export function SubscriptionHelpScreen() {
  const allTiers = getAllTiers();
  const soloTiers = allTiers.filter((tier) => !isTeamTier(tier));
  const teamTiers = allTiers.filter((tier) => isTeamTier(tier));

  return (
    <div className="p-4 space-y-6 pb-24">
      <PageHeader
        title="Тарифные планы"
        subtitle="Выберите тариф для индивидуальной работы или командного использования"
      />

      {/* Solo Tiers */}
      <div className="space-y-3">
        <h2 className="text-lg font-semibold" style={{ color: 'var(--text-primary)' }}>
          Для индивидуального использования
        </h2>
        <p className="text-xs -mt-2" style={{ color: 'var(--text-hint)' }}>
          1 участник
        </p>
        <div className="space-y-4">
          {soloTiers.map((tier) => (
            <Card key={tier.id}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-[17px] font-semibold" style={{ color: 'var(--text-primary)' }}>
                  {tier.name}
                </span>
                {tier.highlight && (
                  <span
                    className="text-xs px-2 py-1 rounded"
                    style={{ backgroundColor: 'var(--accent)', color: '#fff' }}
                  >
                    Популярный
                  </span>
                )}
              </div>
              <div className="mb-3">
                <div className="text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>
                  {formatPrice(tier.price)}
                </div>
                {tier.priceYearly && (
                  <div className="text-sm" style={{ color: 'var(--text-hint)' }}>
                    {formatYearlyPrice(tier.priceYearly)}{' '}
                    <span style={{ color: '#22c55e' }}>(экономия 17%)</span>
                  </div>
                )}
              </div>
              <ul className="space-y-1">
                {tier.features.map((feature, idx) => (
                  <li
                    key={idx}
                    className="text-sm flex items-center gap-2"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    <span style={{ color: '#22c55e' }}>✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>
      </div>

      {/* Team Tiers */}
      <div className="space-y-3">
        <h2 className="text-lg font-semibold" style={{ color: 'var(--text-primary)' }}>
          Для командной работы
        </h2>
        <p className="text-xs -mt-2" style={{ color: 'var(--text-hint)' }}>
          Несколько участников, общая база спортсменов
        </p>
        <div className="space-y-4">
          {teamTiers.map((tier) => (
            <Card key={tier.id}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-[17px] font-semibold" style={{ color: 'var(--text-primary)' }}>
                  {tier.name}
                </span>
                {tier.highlight && (
                  <span
                    className="text-xs px-2 py-1 rounded"
                    style={{ backgroundColor: 'var(--accent)', color: '#fff' }}
                  >
                    Популярный
                  </span>
                )}
              </div>
              <div className="mb-3">
                <div className="text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>
                  {tier.price === 0 ? 'По запросу' : formatPrice(tier.price)}
                </div>
                {tier.priceYearly && tier.priceYearly > 0 && (
                  <div className="text-sm" style={{ color: 'var(--text-hint)' }}>
                    {formatYearlyPrice(tier.priceYearly)}{' '}
                    <span style={{ color: '#22c55e' }}>(экономия 17%)</span>
                  </div>
                )}
              </div>
              <ul className="space-y-1">
                {tier.features.map((feature, idx) => (
                  <li
                    key={idx}
                    className="text-sm flex items-center gap-2"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    <span style={{ color: '#22c55e' }}>✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>
      </div>

      <Card>
        <div className="text-center py-2">
          <p className="text-sm" style={{ color: 'var(--text-hint)' }}>
            {TRIAL_ONCE_RULE} После него платный тариф - только с оплатой.
          </p>
          <p className="text-xs mt-1" style={{ color: 'var(--text-hint)' }}>
            STANDARD и TEAM: 7 дней; PRO, CLUB и PRO TEAM: 14 дней
          </p>
          <p className="text-xs mt-1" style={{ color: 'var(--text-hint)' }}>
            Годовая подписка: экономия 17% от ежемесячных платежей
          </p>
        </div>
      </Card>
    </div>
  );
}
